import { createFileRoute } from "@tanstack/react-router"
import { EmptyState } from "toptaal-shared"

export const Route = createFileRoute("/todo/")({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="flex items-center justify-center screen-height-minus-navbar">
      <EmptyState className="!font-domine">
        Selecteer een taak in je takenmenu
      </EmptyState>
    </div>
  )
}
